import { Container } from '../../components/container';
import styles from './unauthorized.module.css';

export function UnAuthorized() {
  return <Container title="אין גישה לעמוד זה"> </Container>;
}
